(function(){
const OOPSV2_ROOT=document.querySelector('.oopsv2');
if(!OOPSV2_ROOT)return;

/* ================= HERO: photo → pins animation ================= */
/* Hero set — deliberately different from the Drag-it-yourself pairs below */
const HERO_PAIRS = [
  {before:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/hero1-before.jpg", after:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/hero1-after.jpg"},
  {before:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/hero2-before.jpg", after:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/hero2-after.jpg"},
  {before:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/hero3-before.jpg", after:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/hero3-after.jpg"},
  {before:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/hero4-before.jpg", after:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/hero4-after.jpg"},
  {before:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/hero5-before.jpg", after:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/hero5-after.jpg"},
  {before:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/hero6-before.jpg", after:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/hero6-after.jpg"},
  {before:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/hero7-before.jpg", after:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/hero7-after.jpg"}
];
const PAIRS = [
  {label:"You",           before:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/portrait-before.jpg", after:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/portrait-after.png"},
  {label:"Dog",           before:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/dog-before.jpg",      after:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/dog-after.png"},
  {label:"Cat",           before:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/cat-before.jpg",      after:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/cat-after.png"},
  {label:"Favorite album",before:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/music-before.webp",   after:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/music-after.png"},
  {label:"Favorite team", before:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/sport-before.jpg",    after:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/sport-after.png"},
  {label:"Art you love",  before:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/art-before.jpg",      after:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/art-after.png"},
  {label:"Couple",        before:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/couple-before.jpg",   after:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/couple-after.png"},
  {label:"You",           before:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/headphones-before.jpg",after:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/headphones-after.png"},
  {label:"Logo",          before:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/logo-before.jpg",     after:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/logo-after.png"},
  {label:"What you love", before:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/fries-before.jpg",    after:"https://cdn.shopify.com/s/files/1/0699/0810/3338/files/fries-after.png"}
];
const GRID = 48;               // pins per side in the animation
const REVEAL_MS = 2000;        // pin wave duration
const HOLD_MS  = 2200;         // hold finished mosaic
const PHOTO_MS = 700;          // show original photo (brief)

const stage = document.getElementById('stage');
const cv = document.getElementById('heroCanvas');
const ctx = cv.getContext('2d');
const dotsBox = document.getElementById('stageDots');
HERO_PAIRS.forEach((_,i)=>{const d=document.createElement('i');if(i===0)d.classList.add('on');dotsBox.appendChild(d)});

function loadImg(src){return new Promise((res,rej)=>{const im=new Image();im.crossOrigin='anonymous';im.onload=()=>res(im);im.onerror=rej;im.src=src;})}

function coverDraw(c,img,size){ // draw img center-cropped into square canvas ctx
  const s=Math.min(img.width,img.height);
  c.drawImage(img,(img.width-s)/2,(img.height-s)/2,s,s,0,0,size,size);
}

async function heroLoop(){
  const size = 840;
  cv.width = size; cv.height = size;
  let loaded=[];
  try{
    for(const p of HERO_PAIRS){
      const [b,a] = await Promise.all([loadImg(p.before), loadImg(p.after)]);
      loaded.push({before:b, after:a});
    }
  }catch(e){ fallbackSlideshow(); return; }

  const cell=size/GRID;
  let idx=0;
  const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
  // offscreen canvas holding cells that finished popping (real render pixels)
  const done=document.createElement('canvas');done.width=done.height=size;
  const dctx=done.getContext('2d');

  function setDot(i){[...dotsBox.children].forEach((d,k)=>d.classList.toggle('on',k===i))}

  function cycle(){
    const item=loaded[idx]; setDot(idx);
    dctx.clearRect(0,0,size,size);
    const a=item.after, s=Math.min(a.width,a.height);
    const sx0=(a.width-s)/2, sy0=(a.height-s)/2, scell=s/GRID;
    const stamped=new Uint8Array(GRID*GRID);
    const t0=performance.now();

    function drawCellPop(gx,gy,e){
      // the REAL render, cell by cell, popping in with a tiny scale
      const dx=gx*cell, dy=gy*cell, cx=dx+cell/2, cy=dy+cell/2;
      ctx.save();
      ctx.translate(cx,cy);ctx.scale(e,e);ctx.translate(-cx,-cy);
      ctx.drawImage(a, sx0+gx*scell, sy0+gy*scell, scell, scell, dx, dy, cell+0.5, cell+0.5);
      ctx.restore();
    }

    function frame(now){
      const t=now-t0;
      if(t<PHOTO_MS && !reduced){ // phase 1: original photo
        ctx.clearRect(0,0,size,size);
        coverDraw(ctx,item.before,size);
      } else if(t<PHOTO_MS+REVEAL_MS && !reduced){ // phase 2: real-pin wave
        ctx.clearRect(0,0,size,size);
        coverDraw(ctx,item.before,size);
        ctx.drawImage(done,0,0);
        const p=Math.min(1,(t-PHOTO_MS)/REVEAL_MS);
        const maxD=(GRID-1)*2;
        for(let gy=0;gy<GRID;gy++)for(let gx=0;gx<GRID;gx++){
          const k=gy*GRID+gx;
          if(stamped[k])continue;
          const d=(gx+gy)/maxD;
          const local=(p-d*0.82)/0.18;
          if(local<=0)continue;
          if(local>=1){ // finished: stamp real pixels into the done layer
            dctx.drawImage(a, sx0+gx*scell, sy0+gy*scell, scell, scell, gx*cell, gy*cell, cell+0.5, cell+0.5);
            stamped[k]=1;
            drawCellPop(gx,gy,1);
          } else {
            drawCellPop(gx,gy,1-Math.pow(1-local,3));
          }
        }
      } else {finishHold();return}
      requestAnimationFrame(frame);
    }
    function finishHold(){
      ctx.clearRect(0,0,size,size);
      const dw=size; // full real render, center-cropped
      ctx.drawImage(a, sx0, sy0, s, s, 0, 0, dw, dw);
      setTimeout(()=>{idx=(idx+1)%loaded.length;cycle()},HOLD_MS);
    }
    requestAnimationFrame(frame);
  }
  cycle();
}

function fallbackSlideshow(){
  cv.remove();
  let i=0;
  const img=document.createElement('img');img.className='fallback';
  stage.prepend(img);
  const show=()=>{img.src=HERO_PAIRS[i].after; [...dotsBox.children].forEach((d,k)=>d.classList.toggle('on',k===i)); i=(i+1)%HERO_PAIRS.length;};
  show(); setInterval(show,3500);
}
heroLoop();

/* ================= before/after slider ================= */
const ba=document.getElementById('ba'), bImg=document.getElementById('baBefore'), aImg=document.getElementById('baAfter');
const thumbs=document.getElementById('baThumbs');
function setPair(i){
  bImg.src=PAIRS[i].before; aImg.src=PAIRS[i].after;
  [...thumbs.children].forEach((b,k)=>b.classList.toggle('on',k===i));
}

PAIRS.forEach((p,i)=>{
  const wrap=document.createElement('div');
  wrap.className='thumb-wrap';
  const b=document.createElement('button');
  b.innerHTML=`<img src="${p.after}" alt="${p.label} pin mosaic example">`;
  b.onclick=()=>{clearInterval(baTimer);baIdx=i;setPair(i)};
  const lbl=document.createElement('div');
  lbl.className='thumb-label';lbl.textContent=p.label;
  wrap.append(b,lbl);
  thumbs.appendChild(wrap);
});
setPair(0);
/* auto-advance the example pairs until the user takes over */
let baIdx=0;
const baTimer=setInterval(()=>{baIdx=(baIdx+1)%PAIRS.length;setPair(baIdx)},4000);
let dragging=false, userTouched=false;
function setCut(clientX){
  const r=ba.getBoundingClientRect();
  const pct=Math.max(4,Math.min(96,((clientX-r.left)/r.width)*100));
  ba.style.setProperty('--cut',pct+'%');
}
ba.addEventListener('pointerdown',e=>{dragging=true;userTouched=true;clearInterval(baTimer);ba.setPointerCapture(e.pointerId);setCut(e.clientX)});
ba.addEventListener('pointermove',e=>{if(dragging)setCut(e.clientX)});
ba.addEventListener('pointerup',()=>dragging=false);
/* gentle auto-sway until the user grabs the handle */
if(!matchMedia('(prefers-reduced-motion: reduce)').matches){
  (function sway(t0){
    function tick(now){
      if(userTouched) return;
      const p=50+16*Math.sin((now-t0)/1400);
      ba.style.setProperty('--cut',p+'%');
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  })(performance.now());
}

/* ================= reveal on scroll ================= */
const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}}),{threshold:.12});
OOPSV2_ROOT.querySelectorAll('.rv').forEach(el=>io.observe(el));

/* ================= animated counters ================= */
const cio=new IntersectionObserver(es=>es.forEach(e=>{
  if(!e.isIntersecting)return;cio.unobserve(e.target);
  const el=e.target,target=+el.dataset.count,t0=performance.now(),dur=1300;
  (function tick(now){
    const p=Math.min(1,(now-t0)/dur),ease=1-Math.pow(1-p,3);
    el.textContent=Math.round(target*ease).toLocaleString('en-US');
    if(p<1)requestAnimationFrame(tick);
  })(t0);
}),{threshold:.2});
OOPSV2_ROOT.querySelectorAll('[data-count]').forEach(el=>cio.observe(el));

/* ================= marquee: duplicate tracks for seamless loop ================= */
['marqueeTrack','stripTrack'].forEach(id=>{
  const t=document.getElementById(id);
  if(t) t.innerHTML=t.innerHTML+t.innerHTML;
});
/* trust bar: duplicates power the mobile marquee; hidden on desktop via .dup */
const tt=document.getElementById('trustTrack');
if(tt){[...tt.children].forEach(it=>{const c=it.cloneNode(true);c.classList.add('dup');tt.appendChild(c)});}

/* ================= kinetic headlines: split words ================= */
const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
if(!reduced){
  OOPSV2_ROOT.querySelectorAll('h1,h2').forEach(h=>{
    if(h.querySelector('.accent'))return; // keep hero accent markup intact
    h.classList.add('kin');
    h.innerHTML=h.textContent.split(' ').map(w=>`<span class="w"><i>${w}</i></span>`).join(' ');
  });
  const kio=new IntersectionObserver(es=>es.forEach((e,i)=>{
    if(!e.isIntersecting)return;kio.unobserve(e.target);
    [...e.target.querySelectorAll('.w i')].forEach((el,k)=>el.style.transitionDelay=(k*55)+'ms');
    requestAnimationFrame(()=>e.target.classList.add('in'));
  }),{threshold:.4});
  OOPSV2_ROOT.querySelectorAll('.kin').forEach(h=>kio.observe(h));
}

/* ================= sticky mini-CTA after hero ================= */
const sc=document.getElementById('stickyCta');
let heroVis=true, finalVis=false;
const syncSticky=()=>sc.classList.toggle('on',!heroVis&&!finalVis);
new IntersectionObserver(es=>es.forEach(e=>{heroVis=e.isIntersecting;syncSticky()}),{threshold:0}).observe(OOPSV2_ROOT.querySelector('.hero'));
/* hide near final CTA (it has its own button) */
new IntersectionObserver(es=>es.forEach(e=>{finalVis=e.isIntersecting;syncSticky()}),{threshold:.1}).observe(OOPSV2_ROOT.querySelector('.final'));

/* ================= finishes: tap to highlight + show description (mobile) ================= */
const finCards=[...OOPSV2_ROOT.querySelectorAll('.fin')];
const finDesc=document.getElementById('finDesc');
if(finCards.length&&finDesc){
  finCards[0].classList.add('on');
  finCards.forEach(c=>{
    c.addEventListener('click',()=>{
      finCards.forEach(x=>x.classList.remove('on'));
      c.classList.add('on');
      const p=c.querySelector('p');
      if(p)finDesc.textContent=p.textContent;
    });
  });
}

/* ================= finishes: cursor tilt ================= */
if(!reduced){
  OOPSV2_ROOT.querySelectorAll('.fin-card .ph').forEach(ph=>{
    const img=ph.querySelector('img');
    ph.addEventListener('pointermove',e=>{
      const r=ph.getBoundingClientRect();
      const dx=(e.clientX-r.left)/r.width-.5, dy=(e.clientY-r.top)/r.height-.5;
      img.style.animation='none';
      img.style.transform=`rotateY(${dx*16}deg) rotateX(${-dy*16}deg) translateY(-4px)`;
    });
    ph.addEventListener('pointerleave',()=>{img.style.transform='';img.style.animation='';});
  });
}


})();
